"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChooseRecipientsPanel = void 0;
exports.default = getChooseRecipientsPanel;
exports.hasFilters = hasFilters;
exports.isFiltersList = isFiltersList;
exports.isFiltersSegment = isFiltersSegment;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PanelHeaderWithIcon = require("@insided/deprecated-control/ui-components/PanelHeaderWithIcon");

var _OverviewFilters = _interopRequireDefault(require("@insided/deprecated-control/overview/filters/OverviewFilters"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _assets = _interopRequireDefault(require("../../../../preact-components/assets"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _api = require("@insided/control/modules/Analytics/UserSegments/HeaderActions/api");

var _DropdownControl = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownControl"));

var _Message = require("@insided/deprecated-control/ui-components/Message");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function isFiltersList(filters) {
  return filters.type === 'list';
}

function isFiltersSegment(filters) {
  return filters.type === 'segment';
}

function hasFilters(audienceFilters) {
  if (!audienceFilters) {
    return false;
  }

  if (isFiltersList(audienceFilters) && audienceFilters.data) {
    var _audienceFilters$data = audienceFilters.data,
        mainRoles = _audienceFilters$data.mainRoles,
        customRoles = _audienceFilters$data.customRoles,
        joinDate = _audienceFilters$data.joinDate,
        lastActivity = _audienceFilters$data.lastActivity,
        groups = _audienceFilters$data.groups;
    return (mainRoles === null || mainRoles === void 0 ? void 0 : mainRoles.length) > 0 || (customRoles === null || customRoles === void 0 ? void 0 : customRoles.length) > 0 || !!joinDate || !!lastActivity || (groups === null || groups === void 0 ? void 0 : groups.length) > 0;
  }

  if (isFiltersSegment(audienceFilters)) {
    return !!audienceFilters.data;
  }

  return false;
}

var getRecipientsInfoMessage = function getRecipientsInfoMessage(campaignType) {
  if (campaignType && campaignType === 'one-off') {
    return (0, _preact.h)(_Message.Message, {
      customClass: "recipients-count-desc",
      text: (0, _preact.h)("div", null, (0, _preact.h)("span", null, "To prevent high bounce and spam rates, the email will only be sent to users who were active in the last 365 days and haven\u2019t unsubscribed."), ' ', (0, _preact.h)("a", {
        target: "_blank",
        rel: "noreferrer",
        href: "https://community.insided.com/email-campaigns-159/frequently-asked-questions-5592?postid=27666#post27666",
        "data-track-type": "click",
        "data-element-name": "Read more link"
      }, "Read more")),
      variant: "info"
    });
  }

  return null;
};

function getChooseRecipientsPanel(props) {
  var isEditEnabled = props.isEditEnabled,
      onClickPanelCallback = props.onClickPanelCallback,
      campaignType = props.campaignType,
      getRecipientsSummary = props.getRecipientsSummary,
      isDone = props.isDone;
  var hasFilter = hasFilters(props.audienceFilters);
  var oneOffTitle = isEditEnabled ? 'Choose recipients' : 'Recipients';
  var isAutomatedCampaign = campaignType === 'automated';
  var title = isAutomatedCampaign ? 'Triggers' : oneOffTitle;
  return {
    onClick: function onClick() {
      return onClickPanelCallback();
    },
    title: (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
      customClass: "panel-header-container",
      iconCustomClass: "icon-panel-header",
      icon: "usersPlus",
      title: title,
      meta: getRecipientsSummary(),
      isDone: isDone && hasFilter && isEditEnabled
    }),
    body: (0, _preact.h)(ChooseRecipientsPanel, props),
    customClass: 'qa-choose-recipients-panel email-campaigns-recipients-panel'
  };
}

var ChooseRecipientsPanel = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ChooseRecipientsPanel, _Component);

  var _super = _createSuper(ChooseRecipientsPanel);

  function ChooseRecipientsPanel() {
    var _this;

    (0, _classCallCheck2.default)(this, ChooseRecipientsPanel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      searchTerm: ''
    });
    return _this;
  }

  (0, _createClass2.default)(ChooseRecipientsPanel, [{
    key: "hasFilter",
    get: function get() {
      var audienceFilters = this.props.audienceFilters;

      if (isFiltersSegment(audienceFilters)) {
        return !!audienceFilters.data;
      }

      return hasFilters(audienceFilters);
    }
  }, {
    key: "onSegmentClick",
    value: function onSegmentClick(segmentId) {
      var onAudienceFilterChanged = this.props.onAudienceFilterChanged;
      var groupMetrics = this.state.groupMetrics;
      this.setState({
        metrics: groupMetrics === null || groupMetrics === void 0 ? void 0 : groupMetrics.find(function (m) {
          return m.segment_id === segmentId;
        })
      });
      onAudienceFilterChanged('segment', "".concat(segmentId));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          audienceFilters = _this$props.audienceFilters,
          onAudienceFilterChanged = _this$props.onAudienceFilterChanged;
      var isSegmentSelected = isFiltersSegment(audienceFilters);
      (0, _api.loadMetrics)().then(function (r) {
        var _r$data;

        _this2.setState({
          groupMetrics: r.data,
          metrics: isSegmentSelected ? (_r$data = r.data) === null || _r$data === void 0 ? void 0 : _r$data.find(function (m) {
            return "".concat(m.segment_id) === audienceFilters.data;
          }) : null
        }, function () {
          if (_this2.state.metrics) {
            onAudienceFilterChanged('segment', "".concat(_this2.state.metrics.segment_id));
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _segmentGroups$map,
          _this3 = this,
          _selectedSegment$titl;

      var _this$state = this.state,
          _this$state$searchTer = _this$state.searchTerm,
          searchTerm = _this$state$searchTer === void 0 ? '' : _this$state$searchTer,
          metrics = _this$state.metrics;
      var _this$props2 = this.props,
          campaignType = _this$props2.campaignType,
          filters = _this$props2.filters,
          onRecipientsFilterCleared = _this$props2.onRecipientsFilterCleared,
          recipientsCount = _this$props2.recipientsCount,
          isRecipientsCountLoading = _this$props2.isRecipientsCountLoading,
          campaignLimit = _this$props2.campaignLimit,
          onRecipientsFilterDone = _this$props2.onRecipientsFilterDone,
          onAudienceFilterTypeChanged = _this$props2.onAudienceFilterTypeChanged,
          onAudienceFilterChanged = _this$props2.onAudienceFilterChanged,
          audienceFilters = _this$props2.audienceFilters,
          segmentGroups = _this$props2.segmentGroups;
      var hasFilter = this.hasFilter;
      var isAutomatedCampaign = campaignType === 'automated';
      var isOneOffCampaign = campaignType === 'one-off';
      var filtersLabel = isAutomatedCampaign ? 'Triggers' : 'Recipients';
      var hideBtnLabel = isAutomatedCampaign ? 'Hide triggers' : 'Hide filters';
      var isCampaignLimitExceeded = !isRecipientsCountLoading && recipientsCount > campaignLimit;
      var isSegmentSelected = isFiltersSegment(audienceFilters);
      var dropdownList = (_segmentGroups$map = segmentGroups === null || segmentGroups === void 0 ? void 0 : segmentGroups.map(function (segmentGroup) {
        var _segmentGroup$group_n;

        return {
          groupName: (_segmentGroup$group_n = segmentGroup.group_name) !== null && _segmentGroup$group_n !== void 0 ? _segmentGroup$group_n : 'Uncategorized',
          items: segmentGroup.segments.map(function (segment) {
            var _segment$title;

            return {
              title: (_segment$title = segment.title) !== null && _segment$title !== void 0 ? _segment$title : 'Uncategorized',
              value: "".concat(segment.id),
              onClick: function onClick() {
                _this3.onSegmentClick(segment.id);
              }
            };
          })
        };
      })) !== null && _segmentGroups$map !== void 0 ? _segmentGroups$map : [];
      var filteredDropdownList = dropdownList.map(function (group) {
        return _objectSpread(_objectSpread({}, group), {}, {
          items: group.items.filter(function (item) {
            return item.title.toLowerCase().includes(searchTerm.toLowerCase());
          })
        });
      }).filter(function (group) {
        return group.items.length > 0;
      });
      var selectedSegment = isSegmentSelected ? segmentGroups === null || segmentGroups === void 0 ? void 0 : segmentGroups.flatMap(function (segmentGroup) {
        return segmentGroup.segments;
      }).find(function (segment) {
        return "".concat(segment.id) === audienceFilters.data;
      }) : null;
      return (0, _preact.h)("div", {
        className: "panel-body-container"
      }, (0, _preact.h)("div", {
        className: "overview recipients-filter"
      }, (0, _preact.h)("div", {
        className: "recipient-filter__option"
      }, (0, _preact.h)("div", {
        className: "recipient-filter__option__input"
      }, (0, _preact.h)("input", {
        type: "radio",
        name: "filter_type",
        id: "filter_type_list",
        checked: audienceFilters.type === 'list',
        onChange: function onChange() {
          return onAudienceFilterTypeChanged('list');
        }
      }), (0, _preact.h)("label", {
        htmlFor: "filter_type_list"
      }, "Users matching the following criteria")), audienceFilters.type === 'list' && (0, _preact.h)("div", {
        className: "recipient-filter__content"
      }, filters && (0, _preact.h)(_OverviewFilters.default, {
        label: filtersLabel,
        hideBtnLabel: hideBtnLabel,
        filters: filters,
        appliedFilters: audienceFilters.data,
        onFilterChange: function onFilterChange(filter, payload) {
          onAudienceFilterChanged('list', {
            key: filter,
            payload: payload
          });
        },
        onClearFilterCriteria: onRecipientsFilterCleared
      }), hasFilter && !isAutomatedCampaign && (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "recipients-count-text"
      }, recipientsCount, " recipients selected"), getRecipientsInfoMessage(campaignType), isOneOffCampaign && isCampaignLimitExceeded && (0, _preact.h)("div", {
        className: "limit-exceeded-message"
      }, (0, _preact.h)("div", {
        className: "icon"
      }, (0, _preact.h)(_assets.default, {
        icon: "forbidden",
        width: 16,
        height: 16,
        color: "#E94C5C"
      })), (0, _preact.h)("div", {
        className: "message"
      }, "The recipients for this campaign exceed the ".concat(campaignLimit, " user limit for your package. Please narrow down your audience by changing the filters (eg. include Last activity = Less then 365 days ago) or reach out to your CSM to increase the limits for your package.")))), hasFilter && isAutomatedCampaign && (0, _preact.h)("div", null, (0, _preact.h)(_Message.Message, {
        customClass: "recipients-count-desc",
        text: (0, _preact.h)("div", null, (0, _preact.h)("span", null, "This email campaign will only go out to users that match the triggers after publishing the campaign. Users that currently match the triggers will be excluded from this campaign.")),
        variant: "info"
      })))), (0, _preact.h)("div", {
        className: "recipient-filter__option"
      }, (0, _preact.h)(_Tooltip.default, {
        trigger: (0, _preact.h)("div", {
          className: "recipient-filter__option__input ".concat(campaignType === 'automated' ? 'disabled' : '')
        }, (0, _preact.h)("input", {
          disabled: campaignType === 'automated',
          type: "radio",
          name: "filter_type",
          id: "filter_type_segment",
          value: "filter_type_segment",
          checked: audienceFilters.type === 'segment',
          onChange: function onChange() {
            return onAudienceFilterTypeChanged('segment');
          }
        }), (0, _preact.h)("label", {
          htmlFor: "filter_type_segment"
        }, "User segment")),
        tooltipMessage: campaignType === 'automated' ? 'You can only select a segment for one-off campaigns.' : null,
        position: "center",
        withArrow: true,
        customClasses: "graph-help-tooltip"
      }), (0, _preact.h)("div", {
        className: "recipient-filter__content"
      }, isSegmentSelected && (0, _preact.h)("div", {
        className: "email-campaigns-segment-filter"
      }, (0, _preact.h)("div", {
        className: "email-campaigns-segment-dropdown"
      }, (0, _preact.h)(_DropdownControl.default, {
        closeOnDropdownClick: true,
        align: "adjust",
        triggerClass: "dropdown-wrapper",
        trigger: (0, _preact.h)(_Button.default, {
          variant: "secondary",
          size: "medium",
          icon: "arrowDropdown",
          title: (_selectedSegment$titl = selectedSegment === null || selectedSegment === void 0 ? void 0 : selectedSegment.title) !== null && _selectedSegment$titl !== void 0 ? _selectedSegment$titl : 'Select a segment',
          "data-track-type": "click",
          "data-element-name": "Select a segment button"
        }),
        customView: (0, _preact.h)("div", {
          className: "recipient-filter__segment-dropdown"
        }, (0, _preact.h)("ul", null, filteredDropdownList.map(function (group) {
          return (0, _preact.h)("li", {
            key: group.groupName
          }, (0, _preact.h)("div", {
            className: "recipient-filter__segment-dropdown__group-name"
          }, group.groupName), (0, _preact.h)("ul", null, group.items.map(function (item) {
            return (0, _preact.h)("li", {
              key: item.id,
              onClick: item.onClick,
              className: "dropdown-item"
            }, item.title);
          })));
        }))),
        items: filteredDropdownList
      })), metrics && (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "recipient-filter__metrics"
      }, recipientsCount, " recipients currently matching criteria", ' ', (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/users/segments/".concat(metrics === null || metrics === void 0 ? void 0 : metrics.segment_id)),
        "data-track-type": "click",
        "data-element-name": "View Segment link"
      }, "View Segment")), getRecipientsInfoMessage(campaignType))))), hasFilter && isOneOffCampaign && isCampaignLimitExceeded ? null : (0, _preact.h)(_Button.default, {
        title: "Done",
        variant: "brand",
        size: "medium",
        onClick: onRecipientsFilterDone,
        className: "qa-recipients-create-done btn-done",
        "data-track-type": "click",
        "data-element-name": "Done button"
      })));
    }
  }]);
  return ChooseRecipientsPanel;
}(_preact.Component);

exports.ChooseRecipientsPanel = ChooseRecipientsPanel;